import styled from '@emotion/styled';

const InfoWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  width: '50%',
});

export default InfoWrapper;
